import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectRole, selectUser } from "../store/auth/selectors";
import { isPortalUserActionRequired } from "../helpers/userStatusHelper";

export const USER_PROFILE_PATH = "/user/me";
export const PORTAL_DASHBOARD_PATH = "/dashboard";
/** @deprecated Use {@link PORTAL_DASHBOARD_PATH} */
export const WORKER_DASHBOARD_PATH = PORTAL_DASHBOARD_PATH;

const WORKER_ACTION_REQUIRED_ALLOWED_PATHS = new Set([
  PORTAL_DASHBOARD_PATH,
  USER_PROFILE_PATH,
  "/contact-us",
  "/upskilling",
  "/worker/settings",
  "/notifications/list",
]);

const CLIENT_ACTION_REQUIRED_ALLOWED_PATHS = new Set([
  PORTAL_DASHBOARD_PATH,
  USER_PROFILE_PATH,
  "/client/settings",
  "/contact-us",
]);

function ActionRequiredGuard({ children }) {
  const role = useSelector(selectRole);
  const user = useSelector(selectUser);
  const location = useLocation();

  if (!isPortalUserActionRequired(role, user)) {
    return children;
  }

  if (role === "worker") {
    if (WORKER_ACTION_REQUIRED_ALLOWED_PATHS.has(location.pathname)) {
      return children;
    }
    return <Navigate to={PORTAL_DASHBOARD_PATH} replace />;
  }

  if (role === "client") {
    if (CLIENT_ACTION_REQUIRED_ALLOWED_PATHS.has(location.pathname)) {
      return children;
    }
    return <Navigate to={PORTAL_DASHBOARD_PATH} replace />;
  }

  if (location.pathname !== USER_PROFILE_PATH) {
    return <Navigate to={USER_PROFILE_PATH} replace />;
  }

  return children;
}

ActionRequiredGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ActionRequiredGuard;
